import $ from 'jquery'

function setupElement(el) {
  const $src = $(el)
  const elementId = $src.attr('data-source-element-id')
  $src.click(() => {
    const $targetEl = $(`#${elementId}-collapse`)
    if ($targetEl.length > 0) {
      $targetEl.collapse('toggle')
    } else {
      $.get($src.attr('data-url')).then(data => {
        const $sourceEl = $(`#${elementId}`)
        console.log($sourceEl)
        $sourceEl.append(`
          <div id="${elementId}-collapse" class="collapse">
            ${data}
          </div>
        `)
        $(`#${elementId}-collapse`).collapse().collapse('show')
      })
    }
  })
}

$.fn.ajaxCollapseAfter = function() {
  return this.each(function() {
    setupElement(this)
  })
}
